import React from 'react';
// import { Typography } from '@mui/material'; // Currently unused
import Accordion from '../../../../components/Accordion/Accordion'; // Adjust path
import { FieldGroup } from './InputForm'; // Assuming FieldGroup is exported from InputForm.tsx or moved
import { FieldConfig } from '../../../services/ValidationService'; // Adjust path
// import { FormikProps, getIn } from 'formik'; // Currently unused

// Props per il nuovo componente
interface FormSectionProps {
    groupName: string;
    fieldConfigs: FieldConfig[];
    displayMethod: string; // Needed for unique keys
    accordionTitles?: Record<string, string>; // Titoli personalizzati per gli accordion (opzionale)
    // Props da Formik (o passa l'intera bag 'formik')
    values: Record<string, unknown>; // eslint-disable-line @typescript-eslint/no-explicit-any
    setFieldValue: (field: string, value: unknown) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
    // Props comuni/handlers
    t: (key: string, options?: Record<string, unknown>) => string; // eslint-disable-line @typescript-eslint/no-explicit-any
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, setFieldValue: (field: string, value: unknown) => void, fieldName: string) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
    getMeasurementUnit: (unit: string[] | undefined) => string;
    isNewProject: boolean;
    unitSystem: string;
    // Props per Accordion (opzionali, solo se > 1 campo)
    isOpen?: boolean;
    onToggle?: () => void;
}

const FormSection: React.FC<FormSectionProps> = ({
    groupName,
    fieldConfigs,
    displayMethod,
    accordionTitles = {},
    values,
    setFieldValue,
    t,
    handleInputChange,
    getMeasurementUnit,
    isNewProject,
    unitSystem,
    isOpen = false, // Default a false se non è un accordion
    onToggle,
}) => {
    // Helper function per ottenere il titolo dell'accordion
    const getAccordionTitle = (groupName: string): string => {
        return accordionTitles && accordionTitles[groupName] ? t(accordionTitles[groupName]) : t(groupName);
    };

    //TODO: dobbiamo renderizzare accordion se c'è solo 1 elemento?
    // COMMENTED OUT: Logic to auto-open single-field accordions
    // Now all accordions start closed regardless of field count
    /*
    if (fieldConfigs.length === 1 && groupName !== 'geoTextile') {
        return (
            <Accordion
                key={`${displayMethod}-${groupName}`}
                title={getAccordionTitle(groupName)}
                isOpen={true} // Sempre aperto
                onToggle={() => {}} // Disabilita toggle
                data-testid={`accordion-${groupName}`}>
                <FieldGroup
                    groupName={groupName}
                    values={values}
                    dynamicFields={fieldConfigs}
                    setFieldValue={setFieldValue}
                    handleInputChange={handleInputChange}
                    getMeasurementUnit={getMeasurementUnit}
                    t={t}
                    isNewProject={isNewProject}
                    unitSystem={unitSystem}
                />
            </Accordion>
        );
    } else {
    */
    // All accordions now use standard behavior (start closed)
    // --- Renderizza CON Accordion ---
    // onToggle è obbligatorio per l'Accordion, assicurati venga passato
    if (!onToggle) {
        // Potresti voler renderizzare un errore o un placeholder
        return null;
    }
    return (
        <Accordion
            key={`${displayMethod}-${groupName}`}
            title={getAccordionTitle(groupName)} // Title is passed to Accordion, SCSS will style it via .MuiAccordionSummary-content
            isOpen={isOpen} // Usa la prop isOpen
            onToggle={onToggle} // Usa la prop onToggle
            data-testid={`accordion-${groupName}`}>
            <FieldGroup
                groupName={groupName}
                values={values}
                dynamicFields={fieldConfigs}
                setFieldValue={setFieldValue}
                handleInputChange={handleInputChange}
                getMeasurementUnit={getMeasurementUnit}
                t={t}
                isNewProject={isNewProject}
                unitSystem={unitSystem}
            />
        </Accordion>
    );
};

export default FormSection; // Esporta il nuovo componente
